module.exports = __webpack_public_path__ + "img/12.366058a1.png";